/// <reference path="../../jQuery/jquery-1.4.1-vsdoc.js"/>
if (!stuller)
	var stuller = {};
if (!stuller.windowHelper)
	stuller.windowHelper = {};

stuller.windowHelper.windowOpenOptions = function(options) {
	var result = {
		windowParams: {
			location: 'yes',
			status: 'yes',
			scrollbars: 'yes',
			toolbar: 'yes',
			menubar: 'yes',
			directories: 'yes',
			resizable: 'yes',
			width: null,
			height: null
			
		},
		toString: function() {
			var result = new Array();
			var windowParams = this.windowParams;

			for (var nameValueKey in windowParams) {
				if (windowParams[nameValueKey] != null) {
					result.push(nameValueKey + "=" + windowParams[nameValueKey]);
				}
			}
			return result.join(',');
		}
	}
	$.extend(result.windowParams, options);
	return result;
};
stuller.windowHelper.windowOpenOptions.prototype.toString = function() {

	var result = new Array();
	var windowParams = this.windowParams;

	for (var nameValueKey in windowParams) {
		if (windowParams[nameValueKey] != null) {
			result.push(nameValueKey + "=" + windowParams[nameValueKey]);
		}
	}
	return result.join(',');
};


stuller.windowHelper.openMinimalWindow = function(winName, location, width, height) {

	var newWindow;
	var overrideOptions = {
		location: 'no',
		status: 'no',
		scrollbars: 'no',
		toolbar: 'no',
		menubar: 'no',
		directories: 'no',
		resizable: 'no',
		width: width,
		height: height
	}
	var options = new stuller.windowHelper.windowOpenOptions(overrideOptions);
	newWindow = window.open(location, winName, options.toString())
	newWindow.focus();
};

stuller.windowHelper.openStandardWindow = function(location) {
	var newWindow = window.open(location);
	newWindow.focus();
};

stuller.windowHelper.openScrollingWindow = function(winName, loc, width, height) {

	var newWindow;
	var overrideOptions = {
		location: 'no',
		toolbar: 'no',
		menubar: 'no',
		directories: 'no',
		width: width,
		height: height
	}
	var options = new stuller.windowHelper.windowOpenOptions(overrideOptions);
	newWindow = window.open(loc, winName, options.toString())
	newWindow.focus();
};

stuller.windowHelper.openPrintableWindow = function(winName, loc, width, height) {
	var newWindow;
	var overrideOptions = {
		directories: 'no',
		width: width,
		height: height
	}
	var options = new stuller.windowHelper.windowOpenOptions(overrideOptions);
	newWindow = window.open(loc, winName, options.toString())
	newWindow.focus();
};
